export default __webpack_public_path__ + "static/media/certificate-icon.77b5b648.svg";